import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { List, ListItem, ListItemText, ListItemIcon, Badge } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import "./SideNav.css";
import { connect } from "react-redux";
import { logout } from "../../actions/middleware_actions";
import mapStateToProps from "../../services/mapStateToProps";
import About from "../../pages/About";
import { newBroadcastedMessages } from "../../constants/default_request";

function SideNavBar(props) {
  const { client_id, user_full_name, backdrop, isAuthUser, logout, updateChecker } =
    props;
  const [showAbout, setShowAbout] = useState(false);
  const [noMessages, setNoMessages] = useState(0);

  const toggleShowAbout = () => {
    setShowAbout(!showAbout);
  };

  useEffect(() => {
    setNoMessages(newBroadcastedMessages(client_id));
  }, [client_id]);

  const reloadHandler = (event) => {
    event.preventDefault();
    updateChecker();
  };

  return (
    <div onClick={backdrop}>
      {isAuthUser && (
        <>
          <List sx={{ marginTop: "20px" }}>
            <ListItem
              component={Link}
              to={{
                pathname: `${process.env.PUBLIC_URL}/home`,
                state: {
                  client_id: client_id,
                  user_full_name: user_full_name,
                },
              }}
              divider
              style={{ paddingLeft: "10px" }}
            >
              <ListItemIcon style={{ minWidth: "30px" }}>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>

            <ListItem onClick={toggleShowAbout} divider style={{ paddingLeft: "10px" }}>
              <ListItemText primary="About" />
            </ListItem>

            <ListItem
              component={Link}
              to={`${process.env.PUBLIC_URL}/broadcasted-messages`}
              divider
              style={{ paddingLeft: "10px" }}
            >
              <Badge badgeContent={noMessages} color="secondary">
                <ListItemText primary="Messages" />
              </Badge>
            </ListItem>

            <ListItem
              component={Link}
              to={`${process.env.PUBLIC_URL}/start-new-trip`}
              divider
              style={{ paddingLeft: "10px" }}
            >
              <ListItemText primary="New Trip" />
            </ListItem>

            <ListItem
              component={Link}
              to={`${process.env.PUBLIC_URL}/vtr`}
              divider
              style={{ paddingLeft: "10px" }}
            >
              <ListItemText primary="VTR Trip List" />
            </ListItem>
            <ListItem
              component={Link}
              onClick={reloadHandler}
              divider
              style={{ paddingLeft: "10px" }}
            >
              <ListItemText primary="Check for Updates" />
            </ListItem>
            <ListItem
              component={Link}
              to={`${process.env.PUBLIC_URL}/login`}
              onClick={logout}
              divider
              style={{ paddingLeft: "10px" }}
            >
              <ListItemIcon style={{ minWidth: "30px" }}>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
          <About showAbout={showAbout} hideAbout={toggleShowAbout} />
        </>
      )}
    </div>
  );
}

export default connect(mapStateToProps, { logout })(SideNavBar);
